import React from 'react';

const WorkFilter = () => {
    return (
        <div className="work_menu" id="menu-filter">
            <a href="#work" className="active" data-filter="*">All</a>
            <a href="#work" data-filter=".webtemplate">Web Template</a>
            <a href="#work" data-filter=".psdtohtml">PSD to HTML</a>
            <a href="#work" data-filter=".wordpress">WordPress</a>
            <a href="#work" data-filter=".react">React</a>
        </div> // Work menu
    );
};

export default WorkFilter;